// extracted by mini-css-extract-plugin
module.exports = {"resultTopContainer":"index_resultTopContainer__GhnAb","resultsText":"index_resultsText__mJwdP","exportButton":"index_exportButton__2mZsw"};